import { DisciplineOutput, QuestionOutput } from '@/api/gql/graphql';
import { Options } from '@/components/Common/Selects/Select.types';
import { QuizFormMode } from '@/pages/Quizz/quizz.hook';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type QuizStore = {
  formMode: QuizFormMode;
  isOpenQuizModal: boolean;
  openQuizModal: () => void;
  isOpenQuizDeleteModal: boolean;
  openQuizDeleteModal: () => void;
  initialSelectedOptions?: Options | DisciplineOutput | null;
  setInitialSelectedOptions?: (
    initialSelectedOptions: Options | DisciplineOutput | null,
  ) => void;
  selectedQuizz: QuestionOutput | null;
  setSelectedQuizz: (selectedQuizz: QuestionOutput | null) => void;
  setFormMode: (mode: QuizFormMode) => void;
};

export const useQuizStore = create<QuizStore>()(
  persist(
    (set) => ({
      formMode: 'create',
      isOpenQuizModal: false,
      isOpenQuizDeleteModal: false,
      initialSelectedOptions: null,
      selectedQuizz: null,
      openQuizModal: () =>
        set((state) => ({ isOpenQuizModal: !state.isOpenQuizModal })),
      openQuizDeleteModal: () =>
        set((state) => ({
          isOpenQuizDeleteModal: !state.isOpenQuizDeleteModal,
        })),
      setInitialSelectedOptions: (
        initialSelectedOptions: Options | DisciplineOutput | null,
      ) => set({ initialSelectedOptions }),
      setSelectedQuizz: (selectedQuizz: QuestionOutput | null) =>
        set({ selectedQuizz }),
      setFormMode: (mode) => set({ formMode: mode }),
    }),
    {
      name: 'quiz-ui-storage', // nom unique pour identifier ce stockage
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        selectedQuizz: state.selectedQuizz,
        formMode: state.formMode,
      }), // sauvegarde uniquement l'état nécessaire
    },
  ),
);
